var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _ellipse2, _path24, _path25, _g, _ellipse3, _circle, _g2, _path26, _path27, _path28, _path29, _g3, _path30, _path31, _ellipse4, _g4, _path32, _path33, _circle2, _g5, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMadScientist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#330096"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00049 21.8014L12.6148 19.0157L14.3785 22.6925L8.20873 22.5772C7.78954 22.5694 7.64157 22.0181 8.00049 21.8014Z",
    fill: "#2FECC3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8473 29.3958L12.6694 18.7875",
    stroke: "#4702CB",
    strokeWidth: 0.418008,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.194 31.7617L20.9685 30.7885",
    stroke: "#02004A",
    strokeWidth: 0.836016,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0431 29.1391C12.8857 28.368 15.2254 25.0249 15.5854 23.9964C15.9885 22.0382 16.4079 19.8336 18.053 17.8787C19.6982 15.9238 22.878 18.639 22.878 18.639C22.8592 19.3568 22.6807 21.0112 22.1178 21.8862C21.5454 22.776 21.9091 23.5637 21.0271 24.2379C21.7444 23.9872 22.4772 23.8725 22.2171 24.5108C21.6516 25.8987 24.0763 28.3116 22.4741 27.6478C18.8754 26.1569 17.693 28.5736 14.0431 29.1391Z",
    fill: "#1A7FE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0812 25.7461L19.7134 27.4426L22.1658 34.0231",
    stroke: "white",
    strokeWidth: 0.836016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8508 25.698C27.1741 24.3055 25.4482 23.8994 24.5439 23.6236C24.1842 23.6986 22.6501 23.9001 21.5618 24.3746C20.4735 24.8492 21.8194 26.2177 21.8194 26.2177C21.8194 26.2177 24.4532 27.2138 24.6031 27.2635L21.2758 29.3885L24.5927 31.5706C25.8516 30.2672 28.5276 27.0906 27.8508 25.698Z",
    fill: "#0161C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1385 25.1417C18.663 24.713 21.0258 25.172 22.0457 25.8098C22.714 26.4781 20.4519 26.735 18.7554 26.735C17.0589 26.735 17.4713 25.6871 18.1385 25.1417Z",
    fill: "#02004A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2452 30.5227C32.7192 29.623 30.4832 30.283 29.3113 32.2706C28.1395 34.2582 28.6446 36.5335 30.1705 37.4333C31.6964 38.333 33.9319 37.6737 35.1039 35.6861C36.2759 33.6985 35.7712 31.4224 34.2452 30.5227Z",
    stroke: "white",
    strokeWidth: 1.25402
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1771 30.5227C15.6511 29.623 13.4151 30.283 12.2431 32.2706C11.0713 34.2582 11.5765 36.5335 13.1024 37.4333C14.6283 38.333 16.8638 37.6737 18.0358 35.6861C19.2078 33.6985 18.703 31.4224 17.1771 30.5227Z",
    stroke: "white",
    strokeWidth: 1.25402
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2935 33.8174L29.5768 27.3911M30.0081 21.8389L27.9236 22.6614L29.5768 27.3911M29.5768 27.3911H19.4924L15.2254 34.0744H22.2685L29.5768 27.3911Z",
    stroke: "#C5A7FF",
    strokeWidth: 0.836016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1041 32.0966C23.7718 32.1737 21.1949 32.814 21.1949 32.814C21.1949 32.814 21.3017 33.9502 21.3262 34.5242C21.3262 34.5242 21.4017 34.5591 21.4395 34.5772C21.5387 34.5516 21.638 34.5261 21.7372 34.5017C23.1332 34.2119 24.5305 33.9211 25.9266 33.6313C26.0812 33.5927 26.2379 33.5566 26.3916 33.5134C26.655 33.4395 27.1329 33.3794 27.1416 33.2793C27.1762 32.889 26.854 32.6374 26.5542 32.4133C26.0704 32.3085 25.5866 32.2036 25.1029 32.0977L25.1041 32.0966Z",
    fill: "#2FECC3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1388 33.3389L21.4092 34.576",
    stroke: "#02004A",
    strokeWidth: 0.209004,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.628 23.5782C22.5298 22.7452 19.1801 22.9483 17.9036 23.4402C17.261 24.1865 17.2997 25.7278 18.2916 26.1418C19.0699 26.4667 20.2811 26.1469 21.4779 25.9069C21.9717 27.7708 20.2999 33.0733 20.2999 33.0733L25.4756 32.0087C25.6263 29.6152 26.7263 24.4113 24.628 23.5782Z",
    fill: "#47A3FE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.199 23.9987C25.3533 23.0219 25.7987 22.525 25.8158 21.8909C26.9982 22.7649 26.7412 22.7653 29.1061 22.8677C30.17 22.9138 31.3861 22.3029 31.728 21.7367C32.146 21.0442 31.5433 20.342 31.3169 20.0402C30.9227 20.3657 28.5683 20.3125 27.9752 20.143C26.5357 19.7317 26.0216 17.3154 25.0448 17.3154L22.1144 20.143L17.5904 17.7781C16.7678 18.1894 16.0995 18.9091 15.6368 20.4514C15.4671 21.0169 14.5572 25.7981 12.5522 25.6438C12.7064 26.0037 12.8093 26.3636 13.529 26.3636C13.0149 28.1629 11.6782 27.0319 10.5472 28.0091C11.8839 28.2147 12.655 29.5421 14.5058 29.0369C17.6675 28.1738 19.5392 25.5385 20.1095 22.1994C20.6112 22.0426 22.0641 22.6904 23.3483 23.2276C24.068 23.3304 24.8906 23.6388 25.199 23.9987Z",
    fill: "#A9D4FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4742 22.5077L27.9751 23.2789L32.5505 20.04",
    stroke: "white",
    strokeWidth: 0.836016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9885 34.3057L22.8422 35.0269",
    stroke: "#02004A",
    strokeWidth: 0.836016,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8009 21.7879C20.8085 21.9045 22.5412 21.3715 23.307 21.4862C24.0728 21.601 24.1211 22.7305 23.5538 23.1242C22.0809 24.1462 18.5156 25.5408 16.9549 23.9735C16.2989 23.3147 14.6272 19.2787 17.5871 17.7515L19.6017 18.846C19.2646 19.6432 18.7673 21.6683 19.8009 21.7879Z",
    fill: "#A9D4FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9087,
    cy: 18.0344,
    rx: 1.69653,
    ry: 1.69653,
    fill: "#F5A577"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1658 21.6848L21.1376 19.5256C21.9557 19.753 22.3142 19.727 22.7827 19.2686L22.4742 21.6848H22.1658Z",
    fill: "#A9D4FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.51 19.7284L19.2438 18.4977C19.4336 18.3126 19.9682 17.9805 20.5885 18.1332C21.1581 18.2734 21.8889 20.2823 22.2685 21.5311L21.9086 21.5825L20.7292 20.943L20.8955 19.9635L19.51 19.7284Z",
    fill: "#DAEDFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.646 22.244L24.1652 22.3259C23.4539 22.2161 21.5333 21.8526 21.6831 22.5671C21.8097 23.1709 23.7622 23.252 23.9654 23.2834C24.128 23.3085 24.351 23.4816 24.4421 23.565C24.5451 23.4595 24.762 23.1774 24.8059 22.8929C24.8498 22.6084 24.7176 22.3417 24.646 22.244Z",
    fill: "#02004A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1108 21.8289L31.4219 21.4532C32.0327 21.0725 33.7256 20.0954 33.1461 19.6515C32.6563 19.2764 31.1233 20.4883 30.9488 20.5971C30.8092 20.6841 30.5273 20.6983 30.4038 20.6945C30.3945 20.8417 30.4141 21.197 30.5664 21.4413C30.7187 21.6856 30.9928 21.8015 31.1108 21.8289Z",
    fill: "#02004A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0294 18.466L24.977 17.1623C24.7046 17.0672 23.9922 16.9818 23.3227 17.4016C22.704 17.7895 22.4937 20.142 22.4228 21.5099L22.6718 21.479L23.9801 20.1729L23.5031 19.3014L25.0294 18.466Z",
    fill: "#DAEDFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1094 23.3588C24.5472 23.2183 24.3462 21.8244 24.1492 21.7524C23.903 21.6624 23.6814 21.7496 23.6254 21.7756C23.5121 21.7234 23.3949 21.584 23.1916 21.5526C23.0697 21.5338 22.8346 21.6189 22.7616 21.6423C22.7499 21.6058 22.4693 21.4473 22.2027 21.556C21.9252 21.6692 21.9706 21.9364 21.9405 22.2438C21.9405 22.2438 22.0029 22.5136 22.2062 22.5449C22.4094 22.5763 22.48 22.119 22.48 22.119C22.4394 22.4942 22.4396 23.2572 22.7648 23.3074C23.0207 23.3469 23.0774 22.8401 23.0709 22.4167C23.1091 22.845 23.2202 23.3776 23.4761 23.4171C23.8013 23.4673 23.7141 22.5695 23.6721 22.1469C23.7219 22.6228 23.7591 23.4712 24.1094 23.3588Z",
    fill: "#FFD3B9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9859 20.4813C33.2469 20.1405 32.2584 19.2132 32.0082 19.2851C31.81 19.342 31.7774 19.4678 31.7482 19.5177C31.6336 19.5368 31.4774 19.4724 31.3089 19.5533C31.1512 19.6291 31.0818 19.8664 31.0383 19.9232C31.0099 19.9009 30.81 19.8958 30.6822 19.9962C30.4714 20.1617 30.7343 20.3814 30.8748 20.6371L31.0947 20.4779C31.2632 20.7919 31.6693 21.3869 31.9454 21.2543C32.1626 21.15 31.9364 20.7248 31.7062 20.398C31.9634 20.7119 32.332 21.0687 32.5492 20.9643C32.8252 20.8317 32.3139 20.1796 32.0237 19.8701C32.3086 20.1233 32.7771 20.7539 32.9859 20.4813Z",
    fill: "#FFD3B9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5336 23.2453C27.3353 22.505 28.5649 21.6859 29.0759 21.3945C29.3844 22.0705 29.8162 23.5515 30.1041 23.8622C29.59 24.0164 27.7816 24.1707 27.5336 23.2453Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.866035,
    cy: 1.35318,
    rx: 0.866035,
    ry: 1.35318,
    transform: "matrix(-0.946064 0.323981 0.323981 0.946063 30.0107 21.0684)",
    fill: "#FFCC00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6928 16.8967C26.5211 17.4135 25.1184 17.3274 24.4386 17.2197L18.9637 16.358C17.7471 17.0759 15.1422 18.3824 14.4552 17.8655C13.7681 17.3487 14.1689 16.7169 14.4552 16.4657C13.668 16.358 12.0291 16.035 11.7715 15.6042C11.5139 15.1735 11.8788 14.5633 12.0935 14.3121C11.2348 13.8096 9.53869 12.5677 9.62457 11.6201C9.71045 10.6725 10.8769 10.5792 11.4495 10.6509C10.8054 10.3638 9.66751 9.488 10.2687 8.28198C10.8698 7.07596 12.7376 7.20517 13.5964 7.42053C13.2386 6.98981 12.802 5.95608 13.9184 5.26693C15.0348 4.57777 16.8168 5.4105 17.5682 5.91301C17.4966 5.51835 17.5682 4.59983 18.427 4.08296C19.2858 3.5661 21.6474 5.59049 22.7208 6.66729C22.7566 5.87763 23.1073 4.29832 24.2237 4.29832C25.3401 4.29832 25.9771 6.59536 26.1561 7.74388C26.4781 7.20548 27.4012 6.17174 28.5176 6.34403C29.634 6.51632 28.8396 9.43084 28.3029 10.8666C28.6607 10.4717 29.4838 9.91897 29.9132 10.8666C30.3426 11.8141 28.5892 13.1278 27.6588 13.6663C27.9809 13.8098 28.6035 14.2477 28.5176 14.8507C28.4317 15.4537 26.9075 15.6763 26.1561 15.7122C26.4066 15.8916 26.8646 16.3798 26.6928 16.8967Z",
    fill: "#EBE1FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8341_78233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 21,
    height: 14
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6928 16.8967C26.5211 17.4135 25.1184 17.3274 24.4386 17.2197L18.9637 16.358C17.7471 17.0759 15.1422 18.3824 14.4552 17.8655C13.7681 17.3487 14.1689 16.7169 14.4552 16.4657C13.668 16.358 12.0291 16.035 11.7715 15.6042C11.5139 15.1735 11.8788 14.5633 12.0935 14.3121C11.2348 13.8096 9.53869 12.5677 9.62457 11.6201C9.71045 10.6725 10.8769 10.5792 11.4495 10.6509C10.8054 10.3638 9.66751 9.488 10.2687 8.28198C10.8698 7.07596 12.7376 7.20517 13.5964 7.42053C13.2386 6.98981 12.802 5.95608 13.9184 5.26693C15.0348 4.57777 16.8168 5.4105 17.5682 5.91301C17.4966 5.51835 17.5682 4.59983 18.427 4.08296C19.2858 3.5661 21.6474 5.59049 22.7208 6.66729C22.7566 5.87763 23.1073 4.29832 24.2237 4.29832C25.3401 4.29832 25.9771 6.59536 26.1561 7.74388C26.4781 7.20548 27.4012 6.17174 28.5176 6.34403C29.634 6.51632 28.8396 9.43084 28.3029 10.8666C28.6607 10.4717 29.4838 9.91897 29.9132 10.8666C30.3426 11.8141 28.5892 13.1278 27.6588 13.6663C27.9809 13.8098 28.6035 14.2477 28.5176 14.8507C28.4317 15.4537 26.9075 15.6763 26.1561 15.7122C26.4066 15.8916 26.8646 16.3798 26.6928 16.8967Z",
    fill: "#6210FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8341_78233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3632 16.5443C26.2036 17.0497 26.4906 17.0338 25.8588 16.9285L20.7711 16.0858C19.6405 16.7878 16.2751 18.4893 15.6366 17.9838C14.9982 17.4783 15.8847 16.5844 16.1507 16.3387C15.4192 16.2334 13.2541 15.6289 13.0147 15.2077C12.7753 14.7864 13.5886 13.6991 13.7881 13.4534C12.9901 12.962 12.0125 12.379 12.0923 11.4524C12.1721 10.5257 13.2561 10.4344 13.7881 10.5046C13.1896 10.2238 11.942 10.0637 12.5006 8.88431C13.0593 7.70489 14.5815 7.97728 15.3796 8.18789C15.0471 7.76667 14.3421 6.96665 15.3796 6.2927C16.4171 5.61874 17.5088 6.43931 18.2071 6.93073C18.1406 6.54478 18.2649 5.3797 19.063 4.87424C19.861 4.36877 21.9907 5.87768 22.9883 6.93073C23.0215 6.15849 23.4417 4.61719 24.4791 4.61719C25.5166 4.61719 26.0428 6.57857 26.2091 7.70176C26.5083 7.17523 27.521 6.32645 28.471 6.77638C29.4478 7.23907 28.5224 9.39828 28.3682 10.8378C28.7281 10.6835 29.3185 10.5046 29.5505 11.0434C29.9496 11.9701 28.1017 12.9269 27.2371 13.4534C27.5364 13.5938 28.0367 14.2066 27.9569 14.7963C27.8771 15.386 26.7016 15.6352 26.0034 15.6703C26.2361 15.8458 26.5228 16.0388 26.3632 16.5443Z",
    fill: "white"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.24381,
    cy: 5.24381,
    rx: 5.24381,
    ry: 5.24381,
    transform: "matrix(-1 0 0 1 26.3811 8.62695)",
    fill: "#F5A577"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8341_78233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 8,
    width: 12,
    height: 12
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.24381,
    cy: 5.24381,
    r: 5.24381,
    transform: "matrix(-1 0 0 1 26.3811 8.62695)",
    fill: "#6210FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8341_78233)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.24381,
    cy: 5.24381,
    rx: 5.24381,
    ry: 5.24381,
    transform: "matrix(-1 0 0 1 27.4093 8.62695)",
    fill: "#FFD3B9"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8772 15.0752C15.0094 15.7726 15.7045 16.2265 16.4298 16.089L15.951 13.5635C15.2258 13.701 14.745 14.3778 14.8772 15.0752Z",
    fill: "#F5A577"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9692 15.2394L15.4264 14.5908",
    stroke: "#02004A",
    strokeWidth: 0.313506,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7361 13.3564C24.7361 17.5773 21.343 17.4085 21.343 14.7071L24.7361 13.3564Z",
    fill: "#4702CB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8341_78233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 4,
    height: 4
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7361 13.3564C24.7361 17.5773 21.343 17.4085 21.343 14.7071L24.7361 13.3564Z",
    fill: "#02004A"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8341_78233)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.8057,
    cy: 16.6981,
    rx: 2.6219,
    ry: 1.18243,
    fill: "#6210FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1733 13.0566C24.4878 14.7423 21.1397 15.2971 20.9385 14.2183L24.1733 13.0566Z",
    fill: "white"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2458 10.1357L18.5212 10.5566C18.3308 10.6033 18.214 10.7958 18.2605 10.9863C18.3072 11.1768 18.4997 11.2936 18.6902 11.2471L20.4138 10.8262C20.6044 10.7796 20.7219 10.587 20.6755 10.3965C20.629 10.2059 20.4365 10.0893 20.2458 10.1357ZM24.1091 9.82715C24.0127 9.65623 23.7957 9.59596 23.6248 9.69238L22.321 10.4277C22.1502 10.5241 22.0891 10.7412 22.1853 10.9121C22.2817 11.083 22.4987 11.1433 22.6697 11.0469L23.9744 10.3115C24.1452 10.2151 24.2055 9.99805 24.1091 9.82715Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2737 11.7148C19.2818 11.7148 18.4778 12.5189 18.4778 13.5107C18.4778 14.5026 19.2818 15.3066 20.2737 15.3066C21.2655 15.3066 22.0696 14.5026 22.0696 13.5107C22.0695 12.5189 21.2655 11.7149 20.2737 11.7148Z",
    fill: "#A9D4FF",
    stroke: "#02004A",
    strokeWidth: 0.418008
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8341_78233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 11,
    width: 5,
    height: 5
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.00499,
    cy: 2.00499,
    rx: 2.00499,
    ry: 2.00499,
    transform: "matrix(-1 0 0 1 22.2787 11.5059)",
    fill: "#7EBFFE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8341_78233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6913 12.0936L18.8558 14.9291L17.7265 14.6642L21.2223 11.1464L21.6913 12.0936Z",
    fill: "#DAEDFF"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2737 11.7148C19.2818 11.7148 18.4778 12.5189 18.4778 13.5107C18.4778 14.5026 19.2818 15.3066 20.2737 15.3066C21.2655 15.3066 22.0696 14.5026 22.0696 13.5107C22.0695 12.5189 21.2655 11.7149 20.2737 11.7148Z",
    stroke: "#02004A",
    strokeWidth: 0.418008
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6744 10.2754C23.6826 10.2754 22.8786 11.0794 22.8785 12.0713C22.8785 13.0632 23.6825 13.8672 24.6744 13.8672C25.6663 13.8671 26.4703 13.0631 26.4703 12.0713C26.4703 11.0795 25.6663 10.2754 24.6744 10.2754Z",
    fill: "#A9D4FF",
    stroke: "#02004A",
    strokeWidth: 0.418008
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8341_78233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 10,
    width: 5,
    height: 5
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.00499,
    cy: 2.00499,
    r: 1.79598,
    transform: "matrix(-1 0 0 1 26.6793 10.0664)",
    fill: "#7EBFFE",
    stroke: "#02004A",
    strokeWidth: 0.418008
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8341_78233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1125 10.6541L23.277 13.4896L22.1476 13.2248L25.6435 9.70695L26.1125 10.6541Z",
    fill: "#DAEDFF"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6744 10.2754C23.6826 10.2754 22.8786 11.0794 22.8785 12.0713C22.8785 13.0632 23.6825 13.8672 24.6744 13.8672C25.6663 13.8671 26.4703 13.0631 26.4703 12.0713C26.4703 11.0795 25.6663 10.2754 24.6744 10.2754Z",
    stroke: "#02004A",
    strokeWidth: 0.418008
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2986 21.9725L32.2541 21.4795",
    stroke: "#FFCC00",
    strokeWidth: 0.209004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2542 23.8944L31.2986 23.4014",
    stroke: "#FFCC00",
    strokeWidth: 0.209004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5055 22.6165L31.3124 22.6548",
    stroke: "#FFCC00",
    strokeWidth: 0.209004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadScientist);
export default __webpack_public_path__ + "static/media/mad-scientist.2348bb11336bb6968ecb4fb7aa8f4acb.svg";
export { ForwardRef as ReactComponent };